export const ActionTypes = {
  AUTOSAVE_REQUEST: 'zola/card/customization/AUTOSAVE_REQUEST',
  AUTOSAVE_SUCCESS: 'zola/card/customization/AUTOSAVE_SUCCESS',
  AUTOSAVE_FAILURE: 'zola/card/customization/AUTOSAVE_FAILURE',
};

export const autoSaveRequest = () => ({
  type: ActionTypes.AUTOSAVE_REQUEST,
});

export const autoSaveSuccess = payload => ({
  type: ActionTypes.AUTOSAVE_SUCCESS,
  payload,
});

export const autoSaveFailure = payload => ({
  type: ActionTypes.AUTOSAVE_FAILURE,
  payload,
});



// WEBPACK FOOTER //
// ./src/cards/actions/customization/autosave.js